"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Slider: function() {
        return _index.Slider;
    },
    renderSlider_unstable: function() {
        return _index.renderSlider_unstable;
    },
    sliderCSSVars: function() {
        return _index.sliderCSSVars;
    },
    sliderClassNames: function() {
        return _index.sliderClassNames;
    },
    useSliderState_unstable: function() {
        return _index.useSliderState_unstable;
    },
    useSliderStyles_unstable: function() {
        return _index.useSliderStyles_unstable;
    },
    useSlider_unstable: function() {
        return _index.useSlider_unstable;
    }
});
const _index = require("./components/Slider/index");
